<template>
    <div v-if="informations.infoTravaux" class="row margin-top-20 info-travaux">
        <div class="col-12">
            <base-input :label="$t('infoTravaux.trafficEffect')">
                <textarea
                    class="form-control"
                    rows="3"
                    :disabled="disabled"
                    :placeholder="$t('infoTravaux.trafficEffect')"
                    v-model="informations.infoTravaux.trafficEffect">
                </textarea>
            </base-input>
        </div>
        <div class="col-sm-4" v-for="field in answerFields" :key="field">
            <base-input
                :disabled="disabled"
                :label="$t('infoTravaux.' + field)"
                :placeholder="$t('infoTravaux.answerPlaceholder')"
                v-model="informations.infoTravaux[field]">
            </base-input>
        </div>
        <div class="col-12">
            <base-input :label="$t('infoTravaux.details')">
                <textarea
                    class="form-control"
                    rows="3"
                    :disabled="disabled"
                    :placeholder="$t('infoTravaux.details')"
                    v-model="informations.infoTravaux.details">
                </textarea>
            </base-input>
        </div>
    </div>
</template>

<script>
// The rows of the VSJ Info-travaux notice (vsj_report.tpl), typed as the City writes them.
const defaultInfoTravaux = () => ({
    trafficEffect: '',
    localTraffic: '',
    flaggers: '',
    shopsAccess: '',
    details: ''
});

export default {
    name: 'InfoTravauxComponent',
    props: ['informations', 'disabled'],
    data() {
        return {
            answerFields: ['localTraffic', 'flaggers', 'shopsAccess']
        };
    },
    watch: {
        // Both project forms replace the informations object when a saved project loads,
        // and projects saved before these fields existed have no infoTravaux.
        informations: {
            immediate: true,
            handler(informations) {
                if (!informations) return;
                this.$set(informations, 'infoTravaux', { ...defaultInfoTravaux(), ...informations.infoTravaux });
            }
        }
    }
};
</script>

<style>
/* The theme draws textarea.form-control as an underlined 80px strip; these keep the boxed input look. */
.info-travaux textarea.form-control {
    max-height: none;
    padding: 10px 18px;
    line-height: 1.5;
    resize: vertical;
    border: 1px solid #2b3553;
    border-radius: 0.4285rem;
}
.white-content .info-travaux textarea.form-control {
    border-color: rgba(29, 37, 59, 0.5);
}
</style>
